import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './styles/global.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Provider } from 'react-redux';
import { BrowserRouter, HashRouter } from "react-router-dom";

import { store } from './redux/store';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    {/* < BrowserRouter > */}
    <HashRouter>

      {/* <ErrorBoundary> */}
      <div className="red_overlay">
        <App />
      </div>
      {/* </ErrorBoundary> */}
    </HashRouter>
    {/* </BrowserRouter > */}
  </Provider >
);